export default "__VITE_ASSET__BtbtcOfA__"